import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import PersonInfoSVG from '../../../../images/sales-stream/icons/personInfo.svg';
import PersonTicketSVG from '../../../../images/sales-stream/icons/personTicket.svg';

const useStyles = makeStyles({
  details: {
    fontSize: '14px',
    marginLeft: '5px',
  },
  gradientNumber: {
    background: 'linear-gradient(0deg, #0783FE, #9747FF)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textFillColor: 'transparent',
  },
  userInfoSection: {
    marginTop: '10px',
  },
});

const SalesStreamSummaryUserInfoDetails = ({ item, values }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12}>
      <Grid container style={{ marginBottom: '5px' }}>
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
          <img src={PersonInfoSVG} alt="Info" />
          <span className={classes.details}>{item}</span>
        </Grid>
        <Grid item xs={6}>
          <img src={PersonTicketSVG} alt="Info" />
          <span className={`${classes.details} ${classes.gradientNumber}`}>{values.start - values.current}</span>
          <span className={classes.details}>Sold</span>
        </Grid>
        <Grid item xs={6}>
          <img src={PersonTicketSVG} alt="Info" />
          <span className={`${classes.details} ${classes.gradientNumber}`}>{values.current}</span>
          <span className={classes.details}>Held</span>
        </Grid>
      </Grid>
    </Grid>
  );
};

SalesStreamSummaryUserInfoDetails.propTypes = {
  item: PropTypes.string.isRequired,
  values: PropTypes.shape({ current: PropTypes.number.isRequired, start: PropTypes.number.isRequired }).isRequired,
};

export default SalesStreamSummaryUserInfoDetails;
